import { DrawerLanguageSwitch } from "styles/jss/NavDrawer.styles";
import { useRouter } from "next/router";

export default function DrawerLanguage() {
  const { locale, pathname, query, asPath, push } = useRouter();

  const changeLocale = nextLocale => {
    push({ pathname, query }, asPath, { locale: nextLocale });
  };

  return (
    <DrawerLanguageSwitch>
      <p>{locale === "en" ? "Languages" : "زبان‌ها"}</p>
      <div className={"buttons"}>
        <button
          className={locale === "en" ? "active" : ""}
          onClick={() => changeLocale("en")}
        >
          En
        </button>
        <button
          className={locale === "fa" ? "active" : ""}
          onClick={() => changeLocale("fa")}
        >
          Fa
        </button>
      </div>
    </DrawerLanguageSwitch>
  );
}
